module.exports = __webpack_public_path__ + "img/doorLogo14.645680db.png";